var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 79,
    viewBox: "0 0 100 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3151 45.0795C95.3151 61.5797 81.9391 74.9558 65.4388 74.9558C48.9386 74.9558 35.5625 61.5797 35.5625 45.0795C35.5625 28.5792 48.9386 15.2032 65.4388 15.2032C81.9391 15.2032 95.3151 28.5792 95.3151 45.0795Z",
    stroke: "#FAC600",
    strokeWidth: 7.57427,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7061 45.7647L74.6987 31.6145",
    stroke: "#BBD557",
    strokeWidth: 7.57427,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4927 45.9214L72.5917 55.1788",
    stroke: "#FF9A64",
    strokeWidth: 7.57427,
    strokeLinecap: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4015 45.7104H4",
    stroke: "#2BC5CD",
    strokeWidth: 7.57427,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4047 57.9135H13.2039",
    stroke: "#BBD557",
    strokeWidth: 7.57427,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.1409,
    y: 8.89062,
    width: 8.83665,
    height: 10.099,
    rx: 3.57674,
    transform: "rotate(37 84.1409 8.89062)",
    fill: "#FAC600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8071 14.3614V3",
    stroke: "#FAC600",
    strokeWidth: 7.57427
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4199 4.47271L57.4411 4.47271",
    stroke: "#FAC600",
    strokeWidth: 7.57427,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedClock);
export default __webpack_public_path__ + "static/media/speed-clock.0302c4d140df9677f5ce426a9fa9fca7.svg";
export { ForwardRef as ReactComponent };